import { GetInTouchPage } from "./GetInTouch";
export default GetInTouchPage;
